module.exports = __webpack_public_path__ + "static/media/jamshid.e8f2f6bc.jpg";